import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useSoundPath } from 'hooks/useSoundPath';
import MainSortMarketplace from './MainSortMarketplace';

const MainSortButtons = ({ data }) => {

  const itemConfig = {
    'Buy Packs': { to: '/buypacks', label: 'Buy Packs' },
    'Buy Cards': { to: '../marketplace/cards?status=not_owned,for_sale', label: 'Buy Cards' },
    'Craft Identity': { to: '../crafting/identity', label: 'Craft Identity' },
    'Craft Predicition': { to: '../crafting/prediction', label: 'Craft Predicition' },
    'Sell cards': { component: MainSortMarketplace },
  };

  const playSound = useSoundPath();

  const makeSound = useCallback(() => {
    playSound('main');
  }, [playSound])

  return (
    <>
      {data.map((item) => {
        const config = itemConfig[item];
        if (!config) {
          console.warn(`No configuration found for item: ${item} in MainSortButtons.jsx`);
          return null
        };

        if (config.component) {
          const Component = config.component;
          return <Component key={item} makeSound={makeSound} />;
        }

        return (
          <Link
            key={item}
            onClick={makeSound}
            to={config.to}
            className="gradient-block__search-popup-link"
          >
            {config.label}
          </Link>
        );
      })}
    </>
  );
}

export default MainSortButtons;

// import { Link } from 'react-router-dom';
// import { useSoundPath } from 'hooks/useSoundPath';
// import React from 'react';
// import MainSortMarketplace from './MainSortMarketplace';

// const MainSortButtons = ({ data }) => {
//   const playSound = useSoundPath();

//   const makeSound = () => {
//     playSound('main');
//   }

//   return (
//     <>
//       {
//         data.map((item) => {
//           if (item === 'Buy Packs') return <Link key={item} onClick={makeSound} to='/buypacks' className="gradient-block__search-popup-link">{item}</Link>
//           if (item === 'Buy Cards') return <Link key={item} onClick={makeSound} to='../marketplace/cards?status=not_owned,for_sale' className="gradient-block__search-popup-link">{item}</Link>
//           if (item === 'Craft Identity') return <Link key={item} onClick={makeSound} to='../crafting/identity' className="gradient-block__search-popup-link">{item}</Link>
//           if (item === 'Craft Predicition') return <Link key={item} onClick={makeSound} to='../crafting/prediction' className="gradient-block__search-popup-link">{item}</Link>
//           if (item === 'Sell cards') return <MainSortMarketplace makeSound={makeSound} />
//         })
//       }
//     </>
//   )
// }

// export default MainSortButtons;
